import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setActiveMenuList, setMenuItemData } from "../Redux/systemSlice";

// Pages that belong to a top-level menu but are not listed in its subMenu
// (edit / detail / create screens). key = first URL segment,
// value = path of the top-level menu that owns it.
const EXTRA_PAGE_OWNERS = {
  // Settings
  "settings-peopletype": "settings",
  "custom-edit": "settings",
  "people-edit": "settings",
  certificate: "settings",
  editcertificate: "settings",
  addcertificate: "settings",
  // Reports
  "group-report": "reports",
  designtask: "reports",
  reportcourse: "reports",
  reportgroup: "reports",
  groupdesign: "reports",
  // Others
  CreateCourse: "course",
  viewdetail: "courselist",
  Createformpeople: "people",
  editForm: "people",
  group: "groups",
  createEditgroup: "groups",
};

// Returns the top-level menu that owns the current URL, or undefined.
export const findOwnerMenu = (menuItem, pathname) => {
  const segment = pathname.split("/").filter(Boolean)[0];
  if (!segment || !Array.isArray(menuItem)) return undefined;

  return menuItem.find(
    (menu) =>
      menu.path === segment ||
      menu.subMenu?.some((sub) => sub.path === segment) ||
      EXTRA_PAGE_OWNERS[segment] === menu.path
  );
};

const useSyncMenuWithRoute = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const menuItem = useSelector((state) => state.systemTracking.menuItem);
  const activeMenuList = useSelector((state) => state.systemTracking.activeMenuList);

  useEffect(() => {
    const owner = findOwnerMenu(menuItem, pathname);
    // Not a menu page (e.g. /messages, /notification) - leave the menu alone.
    if (!owner) return;

    const nextList = owner.subMenu || [];
    const listInSync =
      activeMenuList.length === nextList.length &&
      nextList.every((sub, i) => sub.path === activeMenuList[i]?.path);
    const activeInSync = menuItem.every((menu) => menu.active === (menu === owner));

    if (listInSync && activeInSync) return;

    dispatch(
      setMenuItemData(menuItem.map((menu) => ({ ...menu, active: menu === owner })))
    );
    dispatch(setActiveMenuList(nextList));
  }, [pathname, menuItem, activeMenuList, dispatch]);
};

export default useSyncMenuWithRoute;